import LegalShell from "@/components/LegalShell";

export default function Refund() {
    return (
        <LegalShell title="Refund & Cancellation Policy" testId="page-refund">
            <p className="text-sm text-aq-muted">
                <strong>Last updated:</strong> 28 June 2026
            </p>

            <p>
                We want you to feel confident purchasing. This policy explains when refunds apply.
            </p>

            <h2>Before the assessment is taken</h2>
            <p>
                If you change your mind, you may request a full refund at any time{" "}
                <strong>before</strong> your child begins the assessment. Email{" "}
                <a href="mailto:thecounselco@gmail.com">thecounselco@gmail.com</a> from the
                address used at purchase and we will process it.
            </p>

            <h2>After the assessment is taken</h2>
            <p>
                Once your child has started or completed the assessment, the personalised report
                work begins immediately and the fee is non-refundable.
            </p>

            <h2>Failed or duplicate payments</h2>
            <p>
                If you were charged but did not receive access to the assessment, or were charged
                twice, email us with your payment details and we will verify and refund any
                erroneous charge promptly.
            </p>

            <h2>How refunds are issued</h2>
            <p>
                Approved refunds are returned to your original payment method via Razorpay,
                typically within 5–7 business days.
            </p>

            <h2>Contact</h2>
            <p>
                <a href="mailto:thecounselco@gmail.com">thecounselco@gmail.com</a>
            </p>
        </LegalShell>
    );
}
